import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import loadingGif from "../../../components/images/loader.gif";
import popcornGif from "../../../components/images/popcorn.gif";

//components
import {
  Button,
  CurveHolder,
  Span,
  StyledText,
} from "../../../components/common/basic";
import {
  Calender,
  Camera,
  ConfirmIcon,
  Curve,
  CurveOverImage,
  CurveUp,
  DoneBackground,
  DoneIconNew,
  Location,
  NewBackButton,
  Timer,
  VoteIcon,
} from "../../../components/svgs";

// hooks
import { useTheme, useLoyalty } from "../../../hooks";
import { FullScreenSelect } from "../../../components/common";
import { FullScreenSelectView } from "../../../components/common/fullScreenSelect";
import { format } from "date-fns";
import ModalHolder from "./modalHolder";

const regionsData = [
  {
    label: "Greater Accra Region",
    cities: [
      { label: "Accra Central", value: 0 },
      { label: "Achimota", value: 2 },
      { label: "Airport Hills", value: 2 },
      { label: "Airport Residential Area", value: 2 },
      { label: "Akweteyman", value: 3 },
      { label: "Ashaiman", value: 4 },
      { label: "Awoshie", value: 4 },
      { label: "Cantonments", value: 5 },
      { label: "Circle", value: 5 },
      { label: "Dansoman", value: 6 },
      { label: "Darkuman", value: 7 },
      { label: "Dzorwulu", value: 7 },
      { label: "East Legon", value: 8 },
      { label: "Haatso", value: 10 },
      { label: "Labone", value: 11 },
      { label: "Lapaz", value: 11 },
      { label: "Madina", value: 12 },
      { label: "McCarthy Hill", value: 13 },
      { label: "Osu", value: 15 },
      { label: "Roman Ridge", value: 16 },
      { label: "Social Welfare", value: 17 },
      { label: "Spintex", value: 18 },
      { label: "Spanner", value: 18 },
      { label: "Tema", value: 19 },
      { label: "Tesano", value: 22 },
      { label: "Teshie", value: 23 },
      { label: "Tudu", value: 24 },
      { label: "West Legon", value: 25 },
      { label: "Weija", value: 25 },
      { label: "Other", value: 0 },
    ],
  },
  {
    label: "Ashanti Region",
    cities: [
      { label: "Abuakwa", value: 0 },
      { label: "Adum", value: 1 },
      { label: "Atonsu", value: 2 },
      { label: "Ayigya", value: 3 },
      { label: "Bantama", value: 4 },
      { label: "Kejetia", value: 5 },
      { label: "KNUST", value: 6 },
      { label: "Kumasi City Mall", value: 7 },
      { label: "Konongo", value: 8 },
      { label: "Mampong", value: 9 },
      { label: "Nhyiaeso", value: 10 },
      { label: "Obuasi", value: 11 },
      { label: "Suame", value: 12 },
      { label: "Tafo", value: 13 },
    ],
  },
  {
    label: "Western Region",
    cities: [
      { label: "Takoradi Main", value: 0 },
      { label: "Takoradi MC", value: 1 },
      { label: "Tarkwa", value: 2 },
      { label: "Bibiani", value: 3 },
    ],
  },
  {
    label: "Central Region",
    cities: [
      { label: "Cape Coast Abura", value: 0 },
      { label: "Cape Coast", value: 1 },
      { label: "Kasoa", value: 2 },
      { label: "Winneba", value: 3 },
    ],
  },
  {
    label: "Eastern Region",
    cities: [
      { label: "Donkorkrom", value: 0 },
      { label: "Koforidua", value: 1 },
      { label: "New Abirem", value: 2 },
    ],
  },
  {
    label: "Brong Ahafo Region",
    cities: [
      { label: "Goaso", value: 0 },
      { label: "Sunyani", value: 1 },
    ],
  },
  {
    label: "Volta Region",
    cities: [
      { label: "Atimpoku", value: 0 },
      { label: "Ho", value: 1 },
    ],
  },
  { label: "Northern Region", cities: [{ label: "Tamale", value: 0 }] },
  { label: "Upper East Region", cities: [{ label: "Bolgatanga", value: 0 }] },
  { label: "Upper West Region", cities: [{ label: "Wa", value: 0 }] },
];

const MovieManiaTicketGeneration = () => {
  const { themeContext, theme } = useTheme();
  const {
    selectedMovie,
    submitVote,
    voted,
    getMovieList,
    setVotingEnd,
    votingEnd,
    loading,
    ticketCode,
    ticketGenerated,
    setTicketGenerated,
    ticketGenerationErrorMessage,
    reserveTicket,
    movieManiaEligibility,
    updateUserLocation,
    checkMovieManiaEligibility,
    movieManiaStatus,
  } = useLoyalty();

  let history = useHistory();
  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [cityList, setCityList] = useState(null);
  const [isEligible, setEligible] = useState(true);
  const [showLoader, setShowLoader] = useState(true);
  const [ticketRedeemed, setTicketRedeemed] = useState(false);

  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "MovieManiaTicketGeneration",
        firebase_screen_class: "MovieManiaTicketGeneration",
      })
    );
    if (selectedMovie.isGeneric) {
      setEligible(true);
    } else {
      checkMovieManiaEligibility(selectedMovie?.code);
    }
  }, []);

  useEffect(() => {
    if (selectedRegion) {
      if (selectedRegion === "Greater Accra Region") {
        setCityList(
          regionsData[0].cities?.map(({ label }) => ({ label, value: label }))
        );
      } else {
        setSelectedCity(selectedRegion);
      }
    }
  }, [selectedRegion]);

  useEffect(() => {
    if (movieManiaEligibility) {
      const { data } = movieManiaEligibility;
      setEligible(data?.isEligible);
    }
  }, [movieManiaEligibility]);

  useEffect(() => {
    // Check if city is eligible for ticket generation
    if (selectedCity) {
      updateUserLocation({
        code: selectedMovie?.code,
        location: selectedCity,
      });
    }
  }, [selectedCity]);

  const styles = generateStyles();

  const steps = [
    "Present Code on day of viewing at the MTN Accra Mall office to get a ticket",
    "Get access to theater for movie viewing",
  ];

  useEffect(() => {
    setShowLoader(false);
    // setShowLoader(true);
    // setTimeout(() => {
    //   setShowLoader(false);
    //   reserveTicket(selectedMovie?.code);
    // }, 1000);
  }, [selectedMovie?.ticket?.ticketCode == null]);

  const ticketCodeStyle = {
    marginBlockStart: 0,
    marginBlockEnd: 0,
    padding: 2,
    textAlign: "center",
    width: "100%",
    fontFamily: "MTNMedium",
    marginTop: 75,
    color: background,
  };

  let ticketSuccessMessage = (
    <>
      You have received Movie Mania ticket code{" "}
      <span style={ticketCodeStyle} size={12}>
        {ticketCode}
      </span>{" "}
      to be presented at Silverbird Cinemas to get access to the theatre. T&Cs apply.
    </>
  );

  if (selectedMovie?.ticketSuccessMessage) {
    const [beforeTicket, afterTicket] = selectedMovie.ticketSuccessMessage.split("{{ticketCode}}");
    ticketSuccessMessage = (
      <>
        {beforeTicket}
        <span style={ticketCodeStyle} size={12}>
          {ticketCode}
        </span>
        {afterTicket}
      </>
    );
  }


  return (
    <>
      {showLoader && !movieManiaStatus?.hasReserved && (
        <ModalHolder>
          <div>
            <img
              alt={"dialog"}
              src={loadingGif}
              style={{ width: "100%", margin: "0 auto" }}
            />
            <StyledText>Checking for available tickets</StyledText>
          </div>
        </ModalHolder>
      )}
      {!ticketGenerated ? (
        <MainHolder activeTheme={mashupBackground}>
          {isEligible !== true &&
            isEligible !== false &&
            !selectedMovie?.ticket?.ticketCode && (
              <>
                {selectedRegion == null && (
                  <FullScreenSelectView
                    title={"Region"}
                    data={regionsData.map(({ label }) => ({
                      label,
                      value: label,
                    }))}
                    setValue={(val) => {
                      setSelectedRegion(val);
                    }}
                    zIndex={99}
                    closeOnSelect={false}
                    closeView={() => {
                      history.goBack();
                    }}
                  />
                )}

                {selectedRegion && !selectedCity && (
                  <FullScreenSelectView
                    title={"Location"}
                    data={cityList || []}
                    setValue={(val) => setSelectedCity(val)}
                    zIndex={99}
                    closeOnSelect={false}
                    closeView={() => {
                      setSelectedRegion(null);
                      setSelectedCity(null);
                    }}
                  />
                )}
              </>
            )}

          <Children>
            <BackButtonContainer
              onClick={() => {
                history.goBack();
              }}
            >
              <NewBackButton />
            </BackButtonContainer>
            <Header>
              <Image src={selectedMovie?.imageUrl} />
              <Gradient>
                <GradientBody>
                  <StyledText
                    color={"white"}
                    style={{
                      marginBlockStart: 0,
                      marginBlockEnd: 0,
                      padding: 2,
                      textAlign: "start",
                      width: "90%",
                    }}
                    size={22}
                  >
                    {selectedMovie?.title}
                  </StyledText>
                  <StyledText
                    color={"white"}
                    style={{
                      marginBlockStart: 0,
                      marginBlockEnd: 0,
                      padding: 2,
                      textAlign: "start",
                      fontFamily: "MTNLight",
                      width: "90%",
                    }}
                    size={14}
                  >
                    {selectedMovie?.isGeneric
                      ? ""
                      : selectedMovie?.genre + " · " + selectedMovie?.duration}
                  </StyledText>
                </GradientBody>
              </Gradient>
            </Header>
            <DescriptionBody color={mashupBackground}>
              <CurveHolder>
                <Curve fill={mashupBackground} />
              </CurveHolder>

              <DescriptionContent>
                {selectedMovie?.isGeneric ? (
                  <>
                    <MovieDetailsItem
                      Icon={Camera}
                      title="Cinema"
                      description={selectedMovie?.cinema}
                    />
                    <MovieDetailsItem
                      Icon={Location}
                      title="Location"
                      description={selectedMovie?.location}
                    />
                  </>
                ) : (
                  <>
                    <MovieDetailsItem
                      Icon={Calender}
                      title="Date"
                      description={format(
                        new Date(selectedMovie?.startDate),
                        "PP"
                      )}
                    />
                    <MovieDetailsItem
                      Icon={Timer}
                      title="Time"
                      description={selectedMovie?.showTime}
                    />
                    <MovieDetailsItem
                      Icon={Camera}
                      title="Cinema"
                      description={selectedMovie?.cinema}
                    />
                    <MovieDetailsItem
                      Icon={Location}
                      title="Location"
                      description={selectedMovie?.location}
                    />

                    <StyledText
                      color={"black"}
                      style={{
                        marginBlockStart: 0,
                        marginBlockEnd: 0,
                        padding: 2,
                        textAlign: "start",
                        width: "100%",
                        fontFamily: "MTNRegular",
                        marginTop: 20,
                      }}
                      size={12}
                    >
                      {selectedMovie?.description}
                    </StyledText>
                  </>
                )}

                {selectedMovie?.ticket?.ticketCode == null ? (
                  <>
                    <Button
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginInline: 15,
                        marginTop: 35,
                      }}
                      disabled={loading || !isEligible}
                      color={background}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!loading && isEligible)
                          reserveTicket(selectedMovie?.code);
                        analytics().then((anl) =>
                          logEvent(
                            anl,
                            "moviemania_ticket_generation_attempt",
                            {
                              movie: selectedMovie?.title,
                            }
                          )
                        );
                      }}
                    >
                      <StyledText style={{ marginRight: 10 }} color={"white"}>
                        {loading || isEligible === null
                          ? `loading...`
                          : `Generate a free ticket code`}
                      </StyledText>
                    </Button>
                    {isEligible === false && (
                      <StyledText
                        style={{ fontSize: "13px", textAlign: "center" }}
                        color={"#f00"}
                      >
                        This offer is not avaliable in your location
                      </StyledText>
                    )}
                    {ticketGenerationErrorMessage && (
                      <StyledText
                        style={{ fontSize: "13px", textAlign: "center" }}
                        color={"#f00"}
                      >
                        {ticketGenerationErrorMessage}
                      </StyledText>
                    )}
                  </>
                ) : (
                  <>
                    {selectedMovie?.ticket?.isRedeemed ? (
                      <>
                        <StyledText
                          style={{
                            marginBlockStart: 0,
                            marginBlockEnd: 0,
                            color: "#0FAF4B",
                            padding: 2,
                            textAlign: "center",
                            width: "100%",
                            // fontFamily: "MTNRegular",
                            marginTop: 20,
                          }}
                        >
                          {"Ticket code redeemed"}
                        </StyledText>
                        <StyledText
                          style={{
                            marginBlockStart: 0,
                            marginBlockEnd: 0,
                            padding: 2,
                            textAlign: "center",
                            width: "100%",
                            // fontFamily: "MTNRegular",
                            color: "#C8CBCB",
                          }}
                        >
                          {selectedMovie?.ticket?.ticketCode}
                        </StyledText>
                      </>
                    ) : (
                      <>
                        <StyledText
                          style={{
                            marginBlockStart: 0,
                            marginBlockEnd: 0,
                            padding: 2,
                            textAlign: "center",
                            width: "100%",
                            // fontFamily: "MTNRegular",
                            marginTop: 20,
                          }}
                        >
                          {"Your ticket Code:"}
                        </StyledText>
                        <StyledText
                          style={{
                            marginBlockStart: 0,
                            marginBlockEnd: 0,
                            padding: 2,
                            textAlign: "center",
                            width: "100%",
                            // fontFamily: "MTNRegular",
                            color: background,
                          }}
                        >
                          {selectedMovie?.ticket?.ticketCode}
                        </StyledText>
                        <ContentHolder>
                          <StyledText
                            size={18}
                            fontFamily={"bold"}
                          >{`How to Redeem your ticket`}</StyledText>
                          {(!selectedMovie?.redemptionSteps || !selectedMovie?.redemptionSteps?.length) ? steps?.map((item, index) => {
                            return (
                              <DescriptionItems key={index}>
                                <CircleContainer>
                                  <ColorCircle color={background} />
                                </CircleContainer>
                                <StyledText size={12} style={styles.textStyle}>
                                  {item}
                                </StyledText>
                              </DescriptionItems>
                            );
                          }) :
                            selectedMovie?.redemptionSteps?.map((item, index) => {
                              return (
                                <DescriptionItems key={index}>
                                  <CircleContainer>
                                    <ColorCircle color={background} />
                                  </CircleContainer>
                                  <StyledText size={12} style={styles.textStyle}>
                                    {item}
                                  </StyledText>
                                </DescriptionItems>
                              );
                            })
                          }
                        </ContentHolder>
                      </>
                    )}
                  </>
                )}
              </DescriptionContent>
            </DescriptionBody>
          </Children>
        </MainHolder>
      ) : (
        <>
          {/* final page */}
          {ticketRedeemed || movieManiaStatus?.hasReserved ? (
            <MainHolder activeTheme={mashupBackground}>
              <Children>
                <BackButtonContainer
                  onClick={() => {
                    // history.goBack();
                    setTicketGenerated(false);
                    const token = JSON.parse(localStorage.getItem("token"));
                    history.push(`/home?token=${token}`);
                  }}
                >
                  <NewBackButton />
                </BackButtonContainer>
                <Header>
                  <Image src={selectedMovie?.imageUrl} />
                  <Gradient>
                    <GradientBody>
                      <StyledText
                        color={"white"}
                        style={{
                          marginBlockStart: 0,
                          marginBlockEnd: 0,
                          padding: 2,
                          textAlign: "start",
                          width: "90%",
                        }}
                        size={22}
                      >
                        {selectedMovie?.title}
                      </StyledText>
                      <StyledText
                        color={"white"}
                        style={{
                          marginBlockStart: 0,
                          marginBlockEnd: 0,
                          padding: 2,
                          textAlign: "start",
                          fontFamily: "MTNLight",
                          width: "90%",
                        }}
                        size={14}
                      >
                        {selectedMovie?.isGeneric
                          ? ""
                          : selectedMovie?.genre +
                            " · " +
                            selectedMovie?.duration}
                      </StyledText>
                    </GradientBody>
                  </Gradient>
                </Header>
                <DescriptionBody color={mashupBackground}>
                  <CurveHolder>
                    <Curve fill={mashupBackground} />
                  </CurveHolder>

                  <DescriptionContent>
                    {selectedMovie?.isGeneric ? (
                      <>
                        <MovieDetailsItem
                          Icon={Camera}
                          title="Cinema"
                          description={selectedMovie?.cinema}
                        />
                        <MovieDetailsItem
                          Icon={Location}
                          title="Location"
                          description={selectedMovie?.location}
                        />
                      </>
                    ) : (
                      <>
                        <MovieDetailsItem
                          Icon={Calender}
                          title="Date"
                          description={format(
                            new Date(selectedMovie?.startDate),
                            "PP"
                          )}
                        />
                        <MovieDetailsItem
                          Icon={Timer}
                          title="Time"
                          description={selectedMovie?.showTime}
                        />
                        <MovieDetailsItem
                          Icon={Camera}
                          title="Cinema"
                          description={selectedMovie?.cinema}
                        />
                        <MovieDetailsItem
                          Icon={Location}
                          title="Location"
                          description={selectedMovie?.location}
                        />

                        <StyledText
                          color={"black"}
                          style={{
                            marginBlockStart: 0,
                            marginBlockEnd: 0,
                            padding: 2,
                            textAlign: "start",
                            width: "100%",
                            fontFamily: "MTNRegular",
                            marginTop: 20,
                          }}
                          size={12}
                        >
                          {selectedMovie?.description}
                        </StyledText>
                      </>
                    )}
                    <StyledText
                      style={{
                        marginBlockStart: 0,
                        marginBlockEnd: 0,
                        padding: 2,
                        textAlign: "center",
                        width: "100%",
                        marginTop: 20,
                      }}
                    >
                      {"Your ticket Code:"}
                    </StyledText>
                    <StyledText
                      style={{
                        marginBlockStart: 0,
                        marginBlockEnd: 0,
                        padding: 2,
                        textAlign: "center",
                        width: "100%",
                        color: background,
                      }}
                    >
                      {ticketCode}
                    </StyledText>
                    <ContentHolder>
                      <StyledText
                        size={18}
                        fontFamily={"bold"}
                      >{`How to Redeem your ticket`}</StyledText>
                      {steps?.map((item, index) => {
                        return (
                          <DescriptionItems key={index}>
                            <CircleContainer>
                              <ColorCircle color={background} />
                            </CircleContainer>
                            <StyledText size={12} style={styles.textStyle}>
                              {item}
                            </StyledText>
                          </DescriptionItems>
                        );
                      })}
                    </ContentHolder>
                  </DescriptionContent>
                </DescriptionBody>
              </Children>
            </MainHolder>
          ) : (
            <div
              style={{
                padding: 10,
                width: "95%",
                // display: ticketRedeemed ? "none" : "block",
              }}
            >
              <StyledText
                style={{
                  marginBlockStart: 0,
                  marginBlockEnd: 0,
                  padding: 2,
                  textAlign: "center",
                  width: "100%",
                  fontFamily: "MTNRegular",
                  marginTop: 75,
                }}
                size={22}
              >
                {"Congrats"}
              </StyledText>
              <img
                alt="popcorn"
                src={popcornGif}
                style={{ width: "100%", margin: "0 auto" }}
              />
              <StyledText
                style={{
                  marginBlockStart: 0,
                  marginBlockEnd: 0,
                  padding: 2,
                  textAlign: "center",
                  width: "100%",
                  fontFamily: "MTNRegular",
                }}
                size={12}
              >
                {ticketSuccessMessage}
              </StyledText>
              <ButtonHolder>
                <Button
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginInline: 15,
                    marginTop: 35,
                    width: "90%",
                  }}
                  color={background}
                  // onClick={(e) => {
                  //   e.preventDefault();
                  //   // setTicketGenerated(false);
                  //   // const token = JSON.parse(localStorage.getItem("token"));
                  //   // history.push(`/home?token=${token}`);
                  // }}
                  onClick={() => {
                    setTicketRedeemed(true);
                  }}
                >
                  <StyledText style={{ marginRight: 10 }} color={"white"}>
                    Great
                  </StyledText>
                </Button>
              </ButtonHolder>
            </div>
          )}
        </>
      )}
    </>
  );
};

const MovieDetailsItem = ({ Icon, title, description }) => (
  <DescriptionItems>
    <Icon width={24} height={14} fill={"#B7BABA"} />
    <StyledText size={14} style={{ margin: "0 0px 0px 10px" }}>
      {title}
    </StyledText>
    <StyledText size={14} style={{ margin: "0 10px" }}>
      -
    </StyledText>
    <StyledText
      size={14}
      style={{
        margin: "0px",
        fontFamily: "MTNLight",
      }}
    >
      {description}
    </StyledText>
  </DescriptionItems>
);

const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
  scrollbar-width: none;
  background-color: ${({ activeTheme }) => activeTheme};
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  margin: 8px;
  z-index: 5;
`;

const Header = styled.div`
  width: 100%;
  height: 300px;
  overflow: hidden;
  position: relative;
  padding: 20;
`;

const Image = styled.img`
  width: 100%;
  height: 360px;
  position: absolute;
`;

const Gradient = styled.div`
  width: 100%;
  height: 300px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.17) 39.58%,
    #000000 100%
  );
  position: absolute;
  z-index: 1;
  display: grid;
  grid-auto-flow: column;
  align-items: flex-start;
`;

const GradientBody = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: column;
  height: 80%;
  justify-content: flex-end;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
  position: relative;
  z-index: 1;
`;

const DescriptionContent = styled.div`
  padding: 10px;
  width: 90%;
`;

const DescriptionItems = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const IconHolder = styled.div`
  display: flex;
  width: 100%;
  margin-top: -55px;
  position: relative;
  align-items: center;
  justify-content: center;
`;

const ContentHolder = styled.div`
  margin-inline: 20px;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-inline: 10px;
`;

const ColorCircle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
  margin-right: 10px;
`;

const DescriptionContentHeader = styled.div`
  padding: 10px;
  width: 95%;
`;

const ButtonHolder = styled.div`
  display: grid;
  align-content: center;
`;

const generateStyles = () => {
  return {
    textStyle: {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
  };
};

export default MovieManiaTicketGeneration;
